export enum TimeSelectionKey {
  SoundSignalStartTime = 'soundSignalStartTime',
  MeasStartTime = 'measStartTime',
}
